


































































































































































































































































import { defineComponent } from "@vue/composition-api"
import Title from "@/app/components/common/Title.vue"
import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"

export default defineComponent({
  components: {
    Title,
    Subtitle,
    Content,
  },
  setup() {
    const validText = "Version 1.4 gültig ab 09.06.2021"

    return {
      validText,
    }
  },
})
